export interface PickedPhoto {
  base64String: string;
  format: 'jpeg' | 'png' | 'gif';
}

/**
 * Abre o seletor de imagem do navegador (no celular, a câmera traseira) e devolve a foto em
 * base64 sem o prefixo do data URL. Substitui o Camera.getPhoto do Capacitor, que no navegador
 * caía nesse mesmo input: o formato devolvido é o que o onboarding já manda ao servidor.
 */
export function pickPhoto(): Promise<PickedPhoto> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.hidden = true;
    input.setAttribute('capture', 'environment');
    document.body.appendChild(input);

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file) {
        input.remove();
        reject(new Error('Nenhuma imagem escolhida'));
        return;
      }

      const format = file.type === 'image/png' ? 'png' : file.type === 'image/gif' ? 'gif' : 'jpeg';
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        input.remove();
        resolve({ base64String: (reader.result as string).split(',')[1], format });
      });
      reader.addEventListener('error', () => {
        input.remove();
        reject(reader.error);
      });
      reader.readAsDataURL(file);
    });

    input.addEventListener('cancel', () => {
      input.remove();
      reject(new Error('Seleção de imagem cancelada'));
    });

    input.click();
  });
}
